export const permission = {
    holidays: 'holidays', //create/update/delete holidays
    working: 'working', //statistics working days/sick leaves
    vacation: 'vacation', //statistics vacation, pending vacations/overtimes, approve/deny vacation request
    overtime: 'overtime', //overtimes approve/deny, pending vacation/overtimes
    team: 'team', //create/update/delete/get teams, attach/detach user to/from team
    user: 'user', //employee get/update/remove/delete
    balanceChanger: 'balanceChanger', //update balance of user
    calendar: 'calendar', //statistics working days/sick leaves
    customer: 'customer', //edit profile, export user calendar, denied all another rights
    settings: 'settings', //edit profile, export user calendar, denied all another rights
};
const all = 'All';
const vacations = 'Vacations';
const sickLeaves = 'Sick leaves';
const holidays = 'National holidays';
const birthdays = 'Birthdays';
const workTimes = 'Work days';
const overtimes = 'Overtimes';

export const calendarTypes = [
    { value: 'all', label: all },
    { value: 'vacations', label: vacations },
    { value: 'sickLeaves', label: sickLeaves },
    { value: 'holidays', label: holidays },
    { value: 'birthdays', label: birthdays },
    { value: 'workTimes', label: workTimes },
    { value: 'overtimes', label: overtimes },
];
export const calendarTypesAsObj = {
    all,
    vacations,
    sickLeaves,
    holidays,
    birthdays,
    workTimes,
    overtimes,
};

export const userCalendarURI = `${window.location.origin}/api/remote-user-calendar/ExistekCalendar.ics?calendarID=`;
export const calendarURI = `${window.location.origin}/api/remote-calendar/ExistekCalendar.ics?calendarID=`;

export const vacationStatusList = {
    '-2': {
        value: 'Declined',
        valueForCalendar: 'Declined',
        backgroundColor: '#DB2828',
        color: '#FFFFFF',
        colorForModal: '#DB2828',
        borderRadius: '24px',
        padding: '3px 12px',
        statusName: 'denied',
    },
    '-1': {
        value: 'Ended',
        valueForCalendar: 'Ended',
        backgroundColor: '#1C63ED',
        color: '#FFFFFF',
        colorForModal: '#1C63ED',
        borderRadius: '24px',
        padding: '3px 12px',
        statusName: 'ended',
    },
    0: {
        value: 'Waiting approval',
        valueForCalendar: 'Waiting',
        backgroundColor: '#EDAF10',
        color: '#FFFFFF',
        colorForModal: '#EDAF10',
        borderRadius: '24px',
        padding: '3px 12px',
        statusName: 'pending',
    },
    1: {
        value: 'Approved',
        valueForCalendar: 'Approved',
        backgroundColor: '#2BB01F',
        color: '#FFFFFF',
        colorForModal: '#2BB01F',
        borderRadius: '24px',
        padding: '3px 12px',
        statusName: 'approved',
    },
};

export const historyChangeStatus = {
    1: 'Vacation created',
    2: 'Vacation updated',
    3: 'Vacation deleted',
    4: 'Admin added',
    5: 'Admin removed',
    6: 'Monthly added',
    7: 'Unused balance write off',
    8: 'Vacation denied',
    9: 'Holiday updated',
    10: 'Holiday removed',
};

export const userStatuses = {
    VACATION: 'Vacation',
    DAY_OFF: 'Day off',
    WORKING: 'Working',
    SICK_LEAVE: 'Sick leave',
    HOLIDAY: 'Holiday',
};
